import { render } from "./Preloader.vue?vue&type=template&id=6bee237c&scoped=true&ts=true"
import script from "./Preloader.vue?vue&type=script&lang=ts"
export * from "./Preloader.vue?vue&type=script&lang=ts"

import "@/components/Shared/Preloader/style.scss?vue&type=style&index=0&id=6bee237c&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bee237c"]])

export default __exports__